/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { router } from './router/Router'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import StoreProvider from './providers/StoreProvider'
import ThemeProvider from './providers/ThemeProvider'
import DynamicFavicon from './components/atoms/DynamicFavicon/DynamicFavicon'
// import { applyPdfWorker } from './libs/react-pdf/pdf.worker'

// applyPdfWorker()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StoreProvider>
    <ThemeProvider>
      <DynamicFavicon />
      <RouterProvider router={router} />
    </ThemeProvider>
  </StoreProvider>
)
